// extracted by mini-css-extract-plugin
export default {"scroller":"uIiK7boF0iw2LZaTPKE3","placeHolderShimmer":"ExBMj0K7UNWlM0DhIhvA"};